import React, { useCallback, useContext, useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import './styles.css';
// import required modules
import { Autoplay, Navigation } from 'swiper/modules';
import { ArrowForwardOutlined, TrendingUpOutlined } from '@mui/icons-material';
import { useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { AppContext } from '../../Layout/Layout';
import { useTranslation } from 'react-i18next';
import ProductCard from '../ProductCatalog/ProductsComponents/ProductCard';
import ProductViewDialog from '../ProductCatalog/ProductsComponents/ProductCommonUIs/ProductViewDialog';

const TrendingSwiper = ({ TrendingProducts }) => {
  const { t } = useTranslation();
  const contextVariable = useContext(AppContext);
  const { ProductRelatedStates, taxDetails: { InventoryStatus } } = useContext(AppContext);
  const isLaptop = useMediaQuery('(min-width: 1024px)');
  // const isTablet = useMediaQuery('(max-width: 1023px) and (min-width: 600px)');
  const isMobile = useMediaQuery('(max-width: 599px)');
  const [AllTrendingProducts, setAllTrendingProducts] = useState([]);
  const [swiperDir, setSwiperDir] = useState(contextVariable.isRTL ? 'rtl' : 'ltr');

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDialogVisible, setDialogVisible] = useState(false);
  const [count, setCount] = useState(1);

  let slidesPerView = 3; // Default value for laptops

  if (isMobile) {
    slidesPerView = 1;
  } else if (isLaptop) {
    slidesPerView = 2;
  }

  useEffect(() => {
    if (TrendingProducts !== "Loading" && TrendingProducts.length > 0) {
      setAllTrendingProducts(TrendingProducts)
    }
    setSwiperDir(contextVariable.isRTL ? 'rtl' : 'ltr');
    //eslint-disable-next-line
  }, [TrendingProducts]);

  const handleProductClick = useCallback(
    (product) => {
      setSelectedProduct(product);
      setDialogVisible(true);
    },
    // eslint-disable-next-line
    [selectedProduct, isDialogVisible],
  )


  const updateChoosingUOM = (ChangeUOMDetails) => {
    // console.log("ChangeUOMDetails", ChangeUOMDetails)
    setSelectedProduct({
      ...selectedProduct,
      ChangeUOMDetails: {
        UOM: ChangeUOMDetails.UOM || ChangeUOMDetails.CorrespondingQuantityTypeCode,
        UOMQty: ChangeUOMDetails.id === 0 ? 1 : ChangeUOMDetails.Quantity
      }
    })
    setCount(1);
    // setProductCardState({ type: "ReduceQty", payload: 1 })
  }

  const handleCloseDialog = async () => {
    setSelectedProduct(null);
    setDialogVisible(false);
    setCount(1);
  }


  const responsiveText = 'lg:text-sm';

  // console.log('AllTrendingProducts',AllTrendingProducts)
  return (
    <div className=' flex flex-column justify-content-start p-2 '>
      {selectedProduct &&
        <>
          <ProductViewDialog selectedProduct={selectedProduct} setDialogVisible={setDialogVisible} isDialogVisible={isDialogVisible}
            count={count} setCount={setCount} updateChoosingUOM={updateChoosingUOM} InventoryStatus={InventoryStatus}
            ProductRelatedStates={ProductRelatedStates} handleCloseDialog={handleCloseDialog} />
        </>
      }

      <div className='flex justify-content-between align-items-baseline'>

        <div>
          <span className='gap-2 text-base font-semibold md:text-xl'>{t("Trending")}</span>
          <TrendingUpOutlined className='glowing text-base mr-2 ml-2' />
        </div>

        <div>
          <Link to={'/productCatalog'}>
            <span className={`flex gap-1 justify-content-between align-items-center font-semibold px-2 py-1 text-white border-round-md ${responsiveText}`}
              style={{ background: "var(--secondary-color)" }}>
              {t("View more")}
              <ArrowForwardOutlined fontSize='small' className='mt-1' />
            </span>
          </Link>
        </div>
      </div>

      <>
        {AllTrendingProducts.length === 0 &&
          <div
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40vh' }}
          >
            <Loader />
          </div>
        }

        {/* Swiper */}
        {
          AllTrendingProducts &&
          <Swiper
            dir={swiperDir}
            modules={[Navigation, Autoplay]}
            navigation={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false, // Allow autoplay to continue even after user interaction
            }}
            slidesPerView={AllTrendingProducts.length === 1 ? 1 : slidesPerView}
            spaceBetween={20}
            className=" "
            style={{}}
          >
            {AllTrendingProducts.map((TrendingProduct, index) => (
              <SwiperSlide key={TrendingProduct.id}>

                <ProductCard Product={TrendingProduct} handleProductClick={handleProductClick} 
                  CardStyle={{ width: "80%", height: "40vh", maxHeight: "40vh", 
                  overflow: "hidden", paddingTop: "5px"  }
                  }
                />

              </SwiperSlide>
            ))}

          </Swiper>}
      </>

    </div>
  );
};
export default TrendingSwiper;